/* eslint-disable */

window.Login = {
    opts: {
        showRequestClass: "request-account",
        showForgotPasswordClass: "forgot-password",
        forgotPasswordUrl: "/api/umbmember/forgotpassword"
    },

    init: function () {
        this.page = $('.login-page')

        if (this.page.length === 0) {
            return
        }
        
        this.loginButton = $("#login-btn");
        this.requestAccountLink = $('#request-account-link')
        this.backToLoginLink = $('.back-to-login-link')
        this.forgotPasswordRequestBtn = $('#send-forgot-password-btn')
        this.toggleTripLoginFormBtn = $('#toggle-trip-login-form')
        
        this.requestSentMessage = $('.request-sent-message')

        this.forgotPasswordPanel = $('.forgot-password-panel')
        this.forgotPasswordUsernameInput = $('#ForgotPasswordUsername')
        this.forgotPasswordLink = $("#forgot-password-link");

        this.sessionIdField = $('.session-id-field')
        if (this.sessionIdField.length > 0) {
            this.sessionIdField.val(this.getOrCreateSessionId())

            this.sessionIdField.each(function() {
                console.log($(this).val())
            })
        }

        this.errorMsg = $('.error-msg')

        this.setListeners()
    },

    getOrCreateSessionId: function () {
        const sessionKey = 'tracking_session_id';
        let id = sessionStorage.getItem(sessionKey);
        if (!id) {
            id = crypto.randomUUID();
            sessionStorage.setItem(sessionKey, id);
        }
        return id;
    },

    setListeners: function () {
        this.loginButton.on("click", () => {
            this.loginButton.addClass('loading');
        })
        
        this.requestAccountLink.on('click', e => {
            e.preventDefault()
            this.page.addClass(this.opts.showRequestClass)
        })

        this.backToLoginLink.on('click', e => {
            e.preventDefault()
            this.page.removeClass(this.opts.showRequestClass)
            this.page.removeClass(this.opts.showForgotPasswordClass)
        })
        
        if (this.toggleTripLoginFormBtn.length > 0) {
            this.toggleTripLoginFormBtn.on('click', e => {
                e.preventDefault()
                this.page.toggleClass('show-trip-login-form')
            });   
        }

        this.forgotPasswordRequestBtn.on('click', e => {
            e.preventDefault()

            if (!this.validateInput(this.forgotPasswordUsernameInput)) {
                return
            }

            this.forgotPasswordRequestBtn.addClass('loading');

            const username = this.forgotPasswordUsernameInput.val()

            $.post(`${this.opts.forgotPasswordUrl}?username=${username}&lang=${window.LANG_STRINGS.locale}`)
                .done((data) => {
                    if (data.Success) {
                        this.requestSentMessage.html(`<p>${data.ResponseMessage}<p>`)
                        this.forgotPasswordPanel.addClass('request-sent')
                        this.forgotPasswordPanel.removeClass('error')
                        this.errorMsg.html('')
                    }
                    else {
                        this.forgotPasswordPanel.addClass('error')
                        this.errorMsg.html(`<p>${data.ResponseMessage}</p>`)
                    }
                })
                .fail((e) => {
                    this.errorMsg.html(`<p>${e.responseJSON.ExceptionMessage}</p>`)
                    console.log(e)
                    this.forgotPasswordPanel.addClass('error')
                })
                .always(() => {
                    this.forgotPasswordRequestBtn.removeClass('loading')
                })
        })

        this.forgotPasswordLink.on('click', e => {
            e.preventDefault()
            this.page.addClass(this.opts.showForgotPasswordClass)
        })
    },

    validateInput(element) {
        const errorClass = "error";

        if (element.val().length === 0) {
            element.addClass(errorClass);
            return false;
        }
        else {
            element.removeClass(errorClass);
            return true;
        }
    },

    validateEmail(element) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const errorClass = "error";

        if (element.val().length === 0 || !re.test(String(element.val()).toLowerCase())) {
            element.addClass(errorClass);
            return false;
        }
        else {
            element.removeClass(errorClass);
            return true;
        }
    }
}

$(function () {
    window.Login.init()
})